/**
 * localStorage/sessionStorage 키 상수 정의
 * 모든 스토리지 키는 여기서 중앙 관리
 */ // 인증 관련 키
export var ACCESS_TOKEN_KEY = 'auth_token'; // OAuth access token (primary)
export var TOKEN_KEY = 'auth_token';
export var USER_KEY = 'auth_user';
export var REFRESH_TOKEN_KEY = 'auth_refresh_token';
export var ID_TOKEN_KEY = 'auth_id_token';
export var LOGOUT_STATE_KEY = 'auth_logout_state';
export var TOKEN_ENDPOINT_URL_KEY = 'auth_token_endpoint_url';
export var ACCESS_TOKEN_EXPIRES_AT_KEY = 'auth_access_token_expires_at';
export var TOKEN_TYPE_KEY = 'auth_token_type';
// i18n 관련 키
export var I18N_LANG_KEY = 'i18n-lang'; // Issue #409: i18n 패키지와 동일한 키 사용 (하이픈)
// OAuth2 관련 키
export var OAUTH2_STATE_KEY = 'oauth2_state';
export var PKCE_CODE_VERIFIER_KEY = 'pkce_code_verifier';
export var OAUTH2_SESSION_ID_KEY = 'oauth2_session_id';
// 기타 앱 관련 키
export var THEME_KEY = 'app_theme';
export var USER_PREFERENCES_KEY = 'user_preferences';
// 레이아웃 관련 키
export var TABLET_VIEW_MODE_KEY = 'layout_tablet_view_mode';
